import React from 'react';
import DataTable from '../../../../components/common/DataTable/DataTable';
import EmptyState from '../../../../components/common/EmptyState/EmptyState';
import Loading from '../../../../components/common/Loading/Loading';
import type { KebabMenuItem } from '../../../../components/common/KebabMenu/KebabMenu';
import type { TrainingItem } from '../../../../types/training';
import TrainingListRow from '../TrainingListRow/TrainingListRow';

export const TRAINING_LIST_HEADERS = [
  'Treino',
  'Splits',
  'Intensidade de carga',
  'Percepção de esforço',
  'Descrição',
  'Ações',
] as const;

export const STUDENT_TRAINING_LIST_HEADERS = [
  'Treino',
  'Splits',
  'Entregue por',
  'Data de entrega',
  'Descrição',
  'Ações',
] as const;

export const TRAINING_LIST_GRID = '1.6fr 130px 120px 150px 1.7fr 120px';
export const STUDENT_TRAINING_LIST_GRID = '1.6fr 130px 190px 140px 1.7fr 120px';

export type TrainingListVariant = 'catalog' | 'student';

interface TrainingListProps {
  trainings: TrainingItem[];
  loading: boolean;
  error: string | null;
  emptyMessage: string;
  highlightTerm?: string;
  variant?: TrainingListVariant;
  onOpen: (training: TrainingItem) => void;
  onApply?: (training: TrainingItem) => void;
  buildMenuItems?: (training: TrainingItem) => KebabMenuItem[];
  showApplyAction?: boolean;
  applyLabel?: string;
  applyDisabled?: boolean;
  applyAlwaysVisible?: boolean;
}

const TrainingList: React.FC<TrainingListProps> = ({
  trainings,
  loading,
  error,
  emptyMessage,
  highlightTerm,
  variant = 'catalog',
  onOpen,
  onApply,
  buildMenuItems,
  showApplyAction = true,
  applyLabel,
  applyDisabled,
  applyAlwaysVisible,
}) => {
  if (error) {
    return <EmptyState message={`Erro: ${error}`} />;
  }

  if (loading) {
    return <Loading />;
  }

  if (trainings.length === 0) {
    return <EmptyState message={emptyMessage} />;
  }

  return (
    <DataTable
      headers={[...(variant === 'student' ? STUDENT_TRAINING_LIST_HEADERS : TRAINING_LIST_HEADERS)]}
      gridTemplate={variant === 'student' ? STUDENT_TRAINING_LIST_GRID : TRAINING_LIST_GRID}
      highlightTerm={highlightTerm}
    >
      {trainings.map((training) => (
        <TrainingListRow
          key={training.id}
          training={training}
          variant={variant}
          onApply={onApply ?? onOpen}
          onOpen={onOpen}
          menuItems={buildMenuItems?.(training) ?? []}
          showApplyAction={showApplyAction}
          applyLabel={applyLabel}
          applyDisabled={applyDisabled}
          applyAlwaysVisible={applyAlwaysVisible}
        />
      ))}
    </DataTable>
  );
};

export default TrainingList;
